// app/javascript/channels/notifications_channel.js
import consumer from "./consumer";

const NotificationsChannel = consumer.subscriptions.create(
  {
    channel: "NotificationsChannel",
    user_id: document.querySelector('meta[name="user-id"]')?.content
  },
  {
    connected() {
      console.log("✅ Connected to NotificationChannel");
    },

    disconnected() {
      console.log("❌ Disconnected from NotificationsChannel");
    },

    received(data) {
      console.log("📢 Received:", data);

      // Location updates go directly to the map — no toast, no sound
      if (data.type === "location_update") {
        window.dispatchEvent(new CustomEvent("staff_location_update", { detail: data }));
        return;
      }

      // Reaches every company user on every page regardless of which (if
      // any) chat conversation they have open, unlike the per-conversation
      // ChatChannel stream - the chat sidebar listens for this to update its
      // unread badge/preview live instead of only after a reload.
      if (data.alert_type === "chat_message" && data.chat_conversation_id) {
        window.dispatchEvent(new CustomEvent("chat_message_notification", { detail: data }));
      }

      this.showNotification(data);
      // alert(data.message)

      let sound;
      if (data.success === "false") {
        sound = new Audio("/sounds/check_call_missed.mp3");
      } else {
        sound = new Audio("/sounds/check_call.mp3");
      }

      const playSound = () => {
        sound.play().catch((error) => {
          console.error("Error playing sound: ", error);
          // You can try to request user interaction here if needed
        });
      };

      if (data.success === "false"){
        toastr.error(data.message, data.title, {
          "timeOut": "10000",
          "extendedTimeOut": 0,
          "progressBar": true,
          "closeButton": true,
          "positionClass": "toast-bottom-right"
        });
        playSound();
      }else{
        toastr.success(data.message, data.title, {
          "timeOut": "10000",
          "extendedTimeOut": 0,
          "progressBar": true,
          "closeButton": true,
          "positionClass": "toast-bottom-right"
        });
        playSound();
      }
    },

    showNotification(data) {
      // Try browser notifications first
      console.log(data)
      if (data.alert_type === "download_report") {
        this.showPopupNotification(data);
      } else {
        if (this.browserNotificationsSupported()) {
          this.showBrowserNotification(data);
        } else {
          this.showToastNotification(data);
        }
      }
    },

    browserNotificationsSupported() {
      return "Notification" in window;
    },

    showBrowserNotification(data) {
      if (Notification.permission === "granted") {
        new Notification(data.title, {
          body: data.message,
          icon: data.icon
        });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            this.showBrowserNotification(data);
          }
        });
      }
    },

    showPopupNotification(data) {
      console.log("This is popup notification:", data);

      Swal.fire({
        title: data.title,
        text: data.message,
        icon: "success",
        showCloseButton: true, // Adds X button in top right
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-download"></i> Download File', // Download button
        cancelButtonText: "Close",
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary',  
          cancelButton: 'btn btn-secondary'
        },
        allowOutsideClick: true
      }).then((result) => {
        if (result.isConfirmed) {
          let fileUrl = data.excel_url || data.pdf_url;
          if (fileUrl) {
            const link = document.createElement("a");
            link.href = fileUrl;
            link.target = "_blank";
            link.rel = "noopener noreferrer"; // Security best practice
            // link.setAttribute("download", "report"); // optional filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            console.warn("No file URL provided in notification");
          }
        }
      });
    },



    showToastNotification(data) {
      // Fallback to toast notifications
      if (typeof Toastify !== 'undefined') {
        Toastify({
          text: data.message,
          duration: 10000,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: this.getAlertColor(data.alert_type)
        }).showToast();
      } else {
        console.warn("Toastify not loaded - notification:", data);
      }
    },

    getAlertColor(alert_type) {
      const colors = {
        sos_alert: "#ff0000",
        default: "#333333"
      };
      return colors[alert_type] || colors.default;
    }
  }
);

export default NotificationsChannel;
